export default {
  discount_badge: '{{value}} di sconto',
  high_caffeine_warning_required: 'Alto contenuto di caffeina',
  pfand: 'Incl. {{value}} di deposito',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcol',
};
